
import * as React from 'react';

import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { getLanguage } from 'react-multi-lang';

interface iProps {page:number,setPage:(val:any)=>void,lastPage:number}
export default function MyPagination({page,setPage,lastPage}:iProps) {
   
    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
      setPage(value);
    };
  
    return (
      <Stack spacing={2} >
        
        <Pagination count={lastPage} page={page} onChange={handleChange} 
        variant='outlined'
        sx={{
          
            '& .MuiPagination-ul': {
              'justifyContent':'center',

            '& .MuiPaginationItem-previousNext':{
              transform:getLanguage()==='en'?'':'rotate(180deg)'
            }
            },
          
          
        }}
        />
      </Stack>
    );
  }